import fi from "./fi";

export default {
  fi: fi,
};